var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlinkToHm9Hh8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.000976562)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 1024,
    height: 1024,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABsCAIAAAAABMCaAAABoUlEQVR42u3aURKDIAwFQO9/6fYKOsmLgMtnp1VYZ4h94foZ5XEhgAjxSMQrMG5N4sb3K/dNrwsiRIjnI5Y22ocoles/RUysCyJEiN9C7Jp0ArdyzbZ1QYQIEWJxI+9afKkgQIQIEeKmiJWwAyJEiBA7ERMBRCJwTYQdECFChBhr6Czw+fbdPogQIY4hpkcidKgcGmhbF0SIEI9EnDwoVHkJn/wtRIgQv4uYaBhNFoquh1cKICBChHgk4ltBwwqIbQEERIgQj0GcLCyThwYSTS6IECGeiRg/+BMGnTz0BBEixPMRK5tueqJvza0tgIAIEeJ2iImN/61GUtcfhHh1hggR4rKIicb87sWnlOJAhAhxa8TJzbjSMEoEE6V5QoQI8UjE9Fj5pb1UPCFChHgkYnqTnrxOumBChAjxW4hdBSTd1O860BQPICBChHgMYmIj77pXonDFUxyIECFCbGyupwOLx3OACBEixNAf/sRLeKJwQYQI8buIiQAiHVJ0NcWWTnEgQoQ4hphuVHU9gHTosHS3DyJEiFFEoyGUNSBC3Hn8Ad5riYd/U6e+AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinkToHm9Hh8);
export default __webpack_public_path__ + "static/media/onlink_to_hm9hh8.6f6fd5e7.svg";
export { ForwardRef as ReactComponent };